"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ProductQuantitySelector;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _Text = _interopRequireDefault(require("./Text"));
var _styles = require("@sart/styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ProductQuantitySelector(props) {
  var decreaseProduct = props.decreaseProduct,
    increaseProduct = props.increaseProduct,
    quantity = props.quantity;
  var _useState = (0, _react.useState)(quantity),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  function decrease(decreaseFunction) {
    decreaseFunction();
    if (value > 0) {
      var newValue = value - 1;
      setValue(newValue);
    }
  }
  function increase(increaseFunction) {
    increaseFunction();
    var newValue = value + 1;
    setValue(newValue);
  }
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.container
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, {
    style: styles.decreaseButton,
    onPress: function onPress() {
      return decrease(decreaseProduct);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], null, "-")), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.value
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], null, value)), /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, {
    style: styles.increaseButton,
    onPress: function onPress() {
      return increase(increaseProduct);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], null, "+")));
}
var styles = _reactNative.StyleSheet.create({
  container: {
    borderColor: _styles.colors.feature,
    backgroundColor: _styles.colors.subtle,
    borderRadius: 8,
    flexDirection: 'row',
    width: 100,
    height: 32,
    justifyContent: 'space-between',
    alignSelf: 'flex-end'
  },
  decreaseButton: {
    flex: 1,
    justifyContent: 'center',
    alignContent: 'flex-end',
    alignItems: 'center',
    borderColor: _styles.colors.feature,
    borderWidth: 1,
    borderRadius: 8
  },
  value: {
    flex: 1,
    color: _styles.colors.feature,
    justifyContent: 'center',
    alignItems: 'center'
  },
  increaseButton: {
    flex: 1,
    justifyContent: 'center',
    alignContent: 'flex-end',
    alignItems: 'center',
    fontSize: 32,
    borderColor: _styles.colors.feature,
    borderWidth: 1,
    borderRadius: 8
  }
});